/**
 * Firebase Console → Project settings → Cloud Messaging → Web Push certificates
 * → "Key pair" (VAPID). Web FCM token için zorunludur.
 */
export const messagingVapidKey = 'BLui4uSnE9X6Ff6kG0JNeUEhJgYitc36VSygNYKuP639uzXUgsk7G1G-HESqam4saCC9ibOvSXVH6Hcdhj6VITY';
